import FallbackJersey from './FallbackJersey';
import HorizontalStriped from './HorizontalStriped';
import Sleeve from './Sleeve';
import Split from './Split';
import VerticalStriped from './VerticalStriped';

export default function Jersey({ jersey, width = 40, height = 40, style, color }) {
  if (!jersey) {
    return <FallbackJersey width={width} height={height} style={style} color={color} />;
  }

  const {
    baseColor,
    stripes,
    stripesColor,
    horizontalStripes,
    horizontalStripesColor,
    sleeveColor,
    sleeveDetail,
    split,
    splitColor
  } = jersey;
  if (stripes && baseColor && stripesColor) {
    return (
      <VerticalStriped
        baseColor={'#' + baseColor}
        stripesColor={'#' + stripesColor}
        width={width}
        height={height}
      />
    );
  } else if (horizontalStripes && horizontalStripesColor) {
    return (
      <HorizontalStriped
        baseColor={'#' + baseColor}
        stripesColor={'#' + horizontalStripesColor}
        width={width}
        height={height}
      />
    );
  } else if (split && splitColor) {
    return (
      <Split
        baseColor={'#' + baseColor}
        splitColor={'#' + splitColor}
        width={width}
        height={height}
      />
    );
  } else if (sleeveColor || sleeveDetail) {
    return (
      <Sleeve
        baseColor={'#' + baseColor}
        sleeveDetailColor={'#' + (sleeveDetail || sleeveColor)}
        width={width}
        height={height}
      />
    );
  }

  return <FallbackJersey width={width} height={height} style={style} color={color} />;
}
